module.exports = __webpack_public_path__ + "img/3.2.1.4b9836fe.png";